<template>
    <div>
        <p>Active</p>

    </div>

</template>

<script>
export default {
    name: 'ActivePools',
    props: ['pool_type']

}
</script>

<style>

</style>